module.exports = __webpack_public_path__ + "img/placeholder-image.1632e46a.png";